<template>
  <v-app
    id="app"
    standalone
    :class="{
      //'primary': $store.getters['navigator/isPrimaryTheme'],
      //gray: $store.getters['navigator/isGrayTheme'],
      normal: $store.getters['navigator/isNormalTheme'],
      'app-audio': $store.state.player.isPlaying,
      'app-video': $store.getters['streamPlayer/hasFrame'],
      'app-header': $store.getters['navigator/hasHeader'],
      'app-footer': $store.getters['navigator/hasFooter'],
    }"
  >
    <!-- Sidebar rendered conditionally based on route -->
    <sidebar v-if="showSidebar && !this.authPage && !this.welcomePage && !this.QRPage && !this.noSidebar"/>

    <v-content :class="{'bg-light': bgLight,'bg-grey': bgGrey, 'bg-dark': bgDark, 'bg-black': bgBlack, 'bg-natural-grey': bgNaturalGrey}">
      <span v-if="!onMobile && isAuthenticated">
        <app-loader v-show="loadValue !== 100" ref="appLoader" @getLoadUpdate="getLoadUpdate" />
      </span>

      <v-container
        fluid
        class="app-container"
        :class="{'onMobile-container': onMobile, 'onMobile-container-fullwidth': noSideSpace, 'no-padding': noPadding, 'no-margin': noMargin, 'not-authenticated': !isAuthenticated, wrapFullHeight}"
      >
        <router-view></router-view>
      </v-container>
    </v-content>

    <stream-player ref="streamPlayer" v-if="currentUser"></stream-player>

    <earn-money-sticker v-if="$store.state.auth.firstVisit" />

    <v-snackbar
      v-model="showError"
      multi-line
      top
      :timeout="$store.state.error.timeout"
      :color="$store.state.error.color"
    >
      <label style="font-weight: 700;">{{ $store.state.error.errors[0] }}</label>
      <v-btn dark flat @click.native="$store.dispatch('error/hideToast')"
        ><v-icon>clear</v-icon></v-btn
      >
    </v-snackbar>

    <v-dialog v-model="show_login_dialog" max-width="500px">
      <login-dialog :dismiss="closeLoginDialog"></login-dialog>
    </v-dialog>

    <v-dialog
      v-model="mobilePlayerActive"
      v-if="onMobile"
      transition="slide-up"
      content-class="no-border-radius"
      fullscreen
    >
      <mobile-player :isPlayerOpened="mobilePlayerActive" />
    </v-dialog>

    <SMS v-if="globalSMSactive" @closeSMS="closeSMS" />
  </v-app>
</template>

<script>
import Vue from 'vue'
import videojs from 'video.js'

import ActivityService from '@/services/activity'
import AuthService from '@/services/auth'
import CategoryService from '@/services/category'
import GenreService from '@/services/genre'
import SettingService from '@/services/setting'
import UserService from '@/services/user'

import appHeader from '@/components/header'
import appFooter from '@/components/footer'
import earnMoneySticker from '@/components/earn_money'
import audioPlayer from '@/components/player'
import mobilePlayer from '@/components/mobile_player'
import streamPlayer from '@/components/stream_player'
import loginDialog from '@/components/login_dialog'
import Sidebar from './components/sidebar'
import AppLoader from '@/components/appLoader'
import SMS from '@/components/SMS'

import { MyEvents, PublicRelationsUsername } from '@/helper'
import { mapState, mapGetters } from 'vuex'

const ActionCable = require('actioncable')
import mobileHeader from "@/views/mobile/components/header";
import mobileFooter from "@/views/mobile/components/footer";

export default {
  name: 'app',

  components: {
    appHeader,
    appFooter,
    earnMoneySticker,
    loginDialog,
    audioPlayer,
    mobilePlayer,
    streamPlayer,
    Sidebar,
    AppLoader,
    mobileHeader,
    mobileFooter,
    SMS,
  },

  data() {
    return {
      loadValue: null,
      direction: 'none',
      cable: null,
      notification_subscription: null,
      show_login_dialog: false,
    }
  },

  computed: {
    ...mapState({
      sideBarWidth: state => state.app.sideBarWidth,
      sideBarMini: state => state.app.sideBarMini,
      mHeaderOp: state => state.appMobile.mobileHeaderOptions,
      mFooterOp: state => state.appMobile.mobileFooterOptions,
      mobilePlayerActive: state => state.player.isMobilePlayerActive,
    }),
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      globalSMSactive: "app/globalSMSactive",
    }),
    showSidebar() {
      return !['Home', 'ForCreators', 'LoginPage', 'SignUpPage'].includes(this.$route.name);
    },
    noSidebar() {
      return this.$route.meta.noSidebar;
    },
    noSideSpace() {
      return this.$route.meta.noSideSpace;
    },
    authPage() {
      return this.$route.meta.authPage;
    },
    QRPage() {
      return this.$route.meta.QRPage;
    },
    welcomePage() {
      return this.$route.meta.welcomePage;
    },
    bgLight() {
      return this.$route.meta.bgLight;
    },
    noPadding() {
      return this.$route.meta.noPadding;
    },
    noMargin() {
      return this.$route.meta.noMargin;
    },
    bgGrey() {
      return this.$route.meta.bgGrey;
    },
    bgNaturalGrey() {
      return this.$route.meta.bgNaturalGrey;
    },
    bgDark() {
      return this.$route.meta.bgDark;
    },
    bgBlack() {
      return this.$route.meta.bgBlack;
    },
    onlyOnMobile() {
      return this.$route.meta.onlyOnMobile;
    },
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser() {
      return this.$store.state.auth.user
    },
    currentPage() {
      return this.$store.state.navigator.current.page
    },
    showError: {
      get: function () {
        return this.$store.state.error.showError
      },
      set: function (newValue) {
        this.$store.dispatch('error/hideToast')
      },
    },
    hideMobileHeader() {
      return this.$route.meta.hideMobileHeader;
    },
    wrapFullHeight() {
      return this.$route.meta.wrapFullHeight;
    },
  },

  watch: {
    mobilePlayerActive(val) {
      console.log('mobilePlayerActive: ', val);
    },
    $route(to, from) {
      this.initLoader()
      const parentNode = document.getElementById('myVideoPlayer')
      this.$nextTick(() => this.watchPip(to, from, parentNode))
      const toPath = to.path.split('/')
      var type = toPath[1]
      if (this.$store.state.auth.token) {
        if (type === 'activity' || type === 'feed') {
          ActivityService.makeRead(type === 'feed' ? 'stream' : type).then(
            (response) => {
              ActivityService.getUnread().then((response) => {
                this.$store.dispatch('activity/setBadge', response.body)
              })
            }
          )
        } else {
          ActivityService.getUnread().then((response) => {
            this.$store.dispatch('activity/setBadge', response.body)
          })
        }
      }
      if (this.$store.state.app.toggleActivity) {
        this.$store.dispatch('app/toggleActivityPopup', false)
      }
    },
  },
  mounted() {
    this.initLoader();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created() {
    console.log('App created')
    Vue.http.interceptors.push((req, next) => {
      next((res) => {
        if (
          res.url.startsWith(process.env.API_BASE_URL) &&
          res.status === 401
        ) {
          AuthService.clearTokenAndUserInfo()
          this.$router.push({ path: '/' })
        }
      })
    })
    this.$root.$on(MyEvents.AUTH_SIGNIN, this.doAfterSignIn)
    this.$root.$on(MyEvents.AUTH_SIGNOUT, this.doAfterSignOut)
    Promise.all([
      SettingService.getSettings(),
      GenreService.getGenres2(),
      CategoryService.getCategories(),
      UserService.getUserInfo(PublicRelationsUsername),
    ]).then((values) => {
      console.log('App initializing...')
      this.$store.dispatch('app/setSettings', values[0].body)
      this.$store.dispatch('app/setGenres', values[1].body)
      this.$store.dispatch('app/setProductCategories', values[2].body)
      this.$store.dispatch('app/setPublicRelationsUser', values[3].body)
    })
    if (AuthService.isAuthenticated()) {
      AuthService.checkTokenValidation().then((response) => {
        if (response.body !== false) {
          AuthService.setUser(response.body)
          this.$root.$emit(MyEvents.AUTH_SIGNIN)
        } else {
          AuthService.clearTokenAndUserInfo()
          this.$router.push({ path: '/login' })
        }
      })
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
    this.$root.$off(MyEvents.AUTH_SIGNIN, this.doAfterSignIn)
    this.$root.$off(MyEvents.AUTH_SIGNOUT, this.doAfterSignOut)
  },
  methods: {
    createFallback() {
      const body = document.querySelector("body")
      body.className = "allChildrenCenter"
      body.style = "height: 100vh"
      const fallback = document.createElement("div");
      fallback.className = "text-center";
      const fallbackText = document.createElement("h3");
      fallbackText.className = "text-center";
      fallbackText.innerText = "Please use desktop or Tablet to continue"
      const fallbackAction = document.createElement("button");
      fallbackAction.innerText = "Reload";
      fallbackAction.onclick = () => location.reload();
      fallback.append(fallbackText, fallbackAction);
      body.replaceChildren(fallback);
    },
    onResize() {
      this.$store.dispatch("app/setWindowsWidth", window.innerWidth)
    },
    initLoader(value = 0) {
      if (!this.onMobile && this.isAuthenticated) {
        this.$refs.appLoader.updateLoader(value)
      }
    },
    getLoadUpdate(val) {
      this.loadValue = val
    },
    doAfterSignIn() {
      const vm = this
      this.cable = ActionCable.createConsumer(
        `${process.env.SOCKET_BASE_URL}?token=${this.$store.state.auth.token}`
      )
      this.notification_subscription = this.cable.subscriptions.create(
        {
          channel: 'NotificationsChannel',
        },
        {
          connected: () => {
            console.log('connected to NotificationsChannel')
          },
          received: (data) => {
            console.log('notification_subscription')
            console.log(data)
            vm.$store.dispatch('activity/addBadge', data)
            UserService.cartItems(vm.currentUser.id).then((response) => {
              vm.$store.dispatch('user/setCartItems', response.body)
            })
          },
          disconnected: () => {
            console.log('disconnected to NotificationsChannel :(')
          },
        }
      )
      this.$intercom.boot({
        user_id: this.currentUser.id,
        name: this.currentUser.display_name,
        email: this.currentUser.email,
        avatar: {
          type: 'avatar',
          image_url: this.currentUser.avatar.url,
        },
        user_hash: this.$store.state.auth.hmac,
        hide_default_launcher: true,
      })
      this.$store.dispatch('error/showLoadingActivity', true)
      Promise.all([
        UserService.getUserInfo(this.currentUser.id),
        ActivityService.getUnread(),
        UserService.cartItems(this.currentUser.id),
      ])
        .then((values) => {
          AuthService.setUser(values[0].body)
          this.$store.dispatch('activity/setBadge', values[1].body)
          this.$store.dispatch('user/setCartItems', values[2].body)
          this.$store.dispatch('error/showLoadingActivity', false)
        })
        .catch((reason) => {
          this.$store.dispatch('error/showLoadingActivity', false)
        })
    },
    doAfterSignOut() {
      if (this.notification_subscription) {
        this.notification_subscription.unsubscribe()
        this.notification_subscription = null
      }
      this.$intercom.shutdown()
    },
    openLoginDialog() {
      this.show_login_dialog = true
    },
    closeLoginDialog() {
      this.show_login_dialog = false
    },
    watchPip(to, from, parentNode) {
      let videoId
      const stream_pipMode = this.$store.state.streamPlayer.pipMode
      if (to.name === 'VideoShow') {
        const pp = videojs('myVideoPlayer')
        videoId = to.params.videoId
        const nodeDetails = this.$store.state.streamPlayer.nodeDetails
        if (from.name === 'VideoShow' || (nodeDetails.videoId && videoId !== nodeDetails.videoId)) {
          if (stream_pipMode) {
            pp.exitPictureInPicture()
            pp.dispose()
          }
        } else {
        }
      } else if (from.name === 'VideoShow') {
        if (stream_pipMode) {
          videoId = from.params.videoId
          const nodeDetails = {}
          nodeDetails.parent = parentNode
          nodeDetails.videoId = videoId
          try {
            this.$store.dispatch('streamPlayer/setPipParentNode', nodeDetails)
          } catch (error) {
            return error
          }
        }
      } else {
        this.closeVideoInDOM()
      }
    },
    closeVideoInDOM() {
      try {
        const pp = videojs('myVideoPlayer')
        if (pp && !pp.isInPictureInPicture()) {
          pp.dispose()
          this.$store.dispatch('streamPlayer/setPipParentNode', {})
        }
      } catch (error) {
        return error
      }
    },
    closeSMS() {
      this.$store.dispatch('app/toggleGlobalSMS', false)
    },
    openSMS() {
      this.$store.dispatch('app/toggleGlobalSMS', true)
    },
  },
}
</script>

<style>
/* Add any global styles here */
body {
  background-color: #000 !important;
}

@media (max-width: 1280px) {
  body {
    background-color: #000 !important;
  }
}

.success-dark {
  border-radius: 10px !important;
  background: #108D44 !important;
  font-weight: 700px;
  font-size: 16px;
}

.error-dark {
  border-radius: 10px !important;
  background: #FF3636 !important;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// App.vue?5c655a8e